<template>
 
  <div
              v-if="faqs.length > 0"
              class="p-element-page shadow bg-white rounded mt-2  "
            >
              <!-- naslov i pitanja nisu h-oznake (pretraga cita pitanja iz FAQPage JSON-LD); stilovi: assets/scss/faqcard.scss -->
              <div class="h5 mb-3">Često postavljana pitanja</div>
              <div
                v-for="(faqItem, idx) in faqs"
                :key="`faq-${idx}`"
                class="faq-item"
              >
                <div class="faq-question">{{ faqItem.question }}</div>
                <p class="faq-answer">{{ faqItem.answer }}</p>
              </div>
            </div>
</template>

<script setup>


const props = defineProps({
  faq: {
    type: [Array, String],
    default: () => []
  }
})

const faqs = computed(() => {
  if (!props.faq) return []

  if (typeof props.faq === 'string') {
    try {
      return JSON.parse(props.faq)
    } catch {
      return []
    }
  }

  return props.faq
})
</script>
 
 